module.exports = __webpack_public_path__ + "img/icon-search.4248b5f3.svg";